export default __webpack_public_path__ + "static/media/user.665d64cd.svg";